import { render, staticRenderFns } from "./SearchResultIsogdSections.vue?vue&type=template&id=4b2fc811&"
import script from "./SearchResultIsogdSections.vue?vue&type=script&lang=js&"
export * from "./SearchResultIsogdSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports